/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Create_Back_To_TypeInputs */

const en_clients_create_back_to_type = /** @type {(inputs: Clients_Create_Back_To_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to type selection`)
};

const pt_br2_clients_create_back_to_type = /** @type {(inputs: Clients_Create_Back_To_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar à escolha do tipo`)
};

/**
* | output |
* | --- |
* | "Back to type selection" |
*
* @param {Clients_Create_Back_To_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_create_back_to_type = /** @type {((inputs?: Clients_Create_Back_To_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Create_Back_To_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_create_back_to_type(inputs)
	return pt_br2_clients_create_back_to_type(inputs)
});